import { EthConnection, isPurchase, weiToEth } from '@dfares/network';
import { EthAddress, Setting, TransactionId, TxIntent } from '@dfares/types';
import { providers } from 'ethers';
import { getBooleanSetting } from '../Utils/SettingsHooks';

// NOTE: old setting: tx is killed if user doesn't click popup within 20s
// const POPUP_TIMEOUT = 20000;

// tx is killed if user doesn't click popup within 200s
const POPUP_TIMEOUT = 200_000;

interface OpenConfirmationConfig {
  contractAddress: EthAddress;
  connection: EthConnection;
  id: TransactionId;
  intent: TxIntent;
  overrides?: providers.TransactionRequest;
  from: EthAddress;
  gasFeeGwei: number;
  gasFeeLimit: number;
}

export async function openConfirmationWindowForTransaction({
  contractAddress,
  connection,
  id,
  intent,
  overrides,
  from,
  gasFeeGwei,
  gasFeeLimit,
}: OpenConfirmationConfig): Promise<void> {
  const config = {
    contractAddress,
    account: connection.getAddress(),
  };
  const autoApproveNonPurchase = getBooleanSetting(
    config,
    Setting.AutoApproveNonPurchaseTransactions
  );
  const autoApprovePurchase = getBooleanSetting(config, Setting.AutoApprovePurchaseTransactions);
  const purchase = isPurchase(overrides);
  const shouldSkipPopup = purchase ? autoApprovePurchase : autoApproveNonPurchase;

  if (!shouldSkipPopup) {
    localStorage.setItem(`${from}-gasFeeGwei`, gasFeeGwei.toString());
    localStorage.setItem(`${from}-gasFeeLimit`, gasFeeLimit.toString());
    const account = connection.getAddress();
    if (!account) throw new Error('no account');
    const balanceEth = weiToEth(await connection.loadBalance(account));
    const method = intent.methodName;
    const popup = window.open(
      `/wallet/${contractAddress}/${from}/${id}/${balanceEth}/${method}`,
      'confirmationwindow',
      'width=600,height=600'
    );
    if (popup) {
      const opened = Date.now();
      await new Promise<void>((resolve, reject) => {
        const interval = setInterval(() => {
          if (popup.closed) {
            const approved = localStorage.getItem(`tx-approved-${from}-${id}`) === 'true';
            if (approved) {
              resolve();
            } else {
              reject(new Error('User rejected transaction.'));
            }
            localStorage.removeItem(`tx-approved-${from}-${id}`);
            clearInterval(interval);
          } else {
            if (Date.now() > opened + POPUP_TIMEOUT) {
              reject(new Error('Approval window popup timed out; check your popups!'));
              localStorage.removeItem(`tx-approved-${from}-${id}`);
              clearInterval(interval);
              popup.close();
            }
          }
        }, 100);
      });
    } else {
      throw new Error(
        "Please enable popups to confirm this transaction. After you've done so, try again."
      );
    }
  }
}
